/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-csp-tracking': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M3.11 2.117a5.5 5.5 0 0 1 7.78 7.778L7.495 13.29a.7.7 0 0 1-.99 0L3.11 9.895a5.5 5.5 0 0 1 0-7.778zm6.789.99A4.1 4.1 0 0 0 4.1 8.905l2.9 2.897 2.898-2.897a4.1 4.1 0 0 0 .166-5.622l-.166-.176zm-2.9.543A2.1 2.1 0 1 1 7 7.85 2.1 2.1 0 0 1 7 3.65zm0 1.4A.7.7 0 1 0 7 6.45a.7.7 0 0 0 0-1.4z" _fill="#2D0645"/><path pid="1" d="M9.334 10.5l-2.333 2.333-.778-.778-.778-.778-.778-.778-.777-.777-.778-1.556-.778-.778V5.055l.778-1.556.778-.777.777-.778 1.556-.778H7.778l1.556.778.778.778.777.777.778 1.556v2.333l-.777 1.556-1.556 1.555z" _fill="#2D0645" _stroke="#2D0645" stroke-width=".267"/><path pid="2" d="M6.999 3.5a2.334 2.334 0 1 1 0 4.669 2.334 2.334 0 0 1 0-4.669zm0 1.556a.778.778 0 1 0 .002 1.556.778.778 0 0 0-.002-1.556z" _fill="#fff"/>'
  }
})
